import { render, staticRenderFns } from "./TranslateProduct.vue?vue&type=template&id=9e887f06"
import script from "./TranslateProduct.vue?vue&type=script&lang=js"
export * from "./TranslateProduct.vue?vue&type=script&lang=js"
import style0 from "./TranslateProduct.vue?vue&type=style&index=0&id=9e887f06&prod&lang=css"
import style1 from "../../../src/assets/styles/sortCss.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports